import React from 'react';

/**
 * Overall compliance bar chart component for posture assessments
 * @param {Object} props
 * @param {Array} props.data - Array of {oes_id, oes_name, overall_compliance}
 */
export default function PostureComplianceBarChart({ data = [] }) {
  // Sort by compliance (descending)
  const sortedData = [...data].sort((a, b) => (b.overall_compliance || 0) - (a.overall_compliance || 0));
  
  // Color coding based on compliance score
  const getComplianceColor = (score) => {
    if (score >= 80) return '#10b981'; // Green
    if (score >= 50) return '#f59e0b'; // Amber
    return '#ef4444'; // Red
  };
  
  return (
    <div className="w-full">
      {sortedData.length === 0 ? (
        <div className="text-center py-8 text-slate-500 text-sm">
          No posture assessment data available
        </div>
      ) : (
        <div className="space-y-2.5">
          {sortedData.map((oes) => {
            const compliance = oes.overall_compliance || 0;
            const widthPercent = Math.min(100, Math.max(0, compliance));
            const color = getComplianceColor(compliance);

            return (
              <div key={oes.oes_id} className="flex items-center gap-3">
                <div className="w-32 text-xs font-medium text-slate-600 truncate text-right" title={oes.oes_name}>
                  {oes.oes_name}
                </div>
                <div className="flex-1 flex items-center gap-2">
                  <div className="flex-1 h-3 bg-slate-100 rounded-full overflow-hidden">
                    <div
                      className="h-full rounded-full transition-all duration-500 ease-out"
                      style={{ width: `${widthPercent}%`, backgroundColor: color }}
                    />
                  </div>
                  <span className="text-xs font-bold text-slate-500 w-10 text-right tabular-nums">
                    {compliance}%
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
